import { xTicket } from "../web3/Types";
import { USDC } from "./UsdcValue";

export class Ticket {
  mainNumbers: readonly bigint[];
  luckyStars: readonly bigint[];
  prize?: USDC;

  constructor(
    numbers: readonly bigint[],
    stars: readonly bigint[],
    prize?: USDC,
  ) {
    this.mainNumbers = numbers;
    this.luckyStars = stars;
    this.prize = prize;
  }

  static empty() {
    return new Ticket([], []);
  }

  static fromTicket(ticket: xTicket): Ticket {
    return new Ticket(ticket.mainNumbers, ticket.luckyStars);
  }

  addPrize(prize: USDC) {
    this.prize = prize;
  }

  toString() {
    return `${this.mainNumbers.map((number, i) => `${i == 0 ? "" : " "}${number}`)},${this.luckyStars.map((star) => ` ${star}`)}`;
  }
}
